module.exports = __webpack_public_path__ + "static/media/1.b6718c3f.jpg";